import classNames from "classnames";
import React from "react";
import QuantityDropdown from "../quantity-dropdown/QuantityDropdown";

const QuantityControlWrapper = ({
  children,
  editable,
  allow_ordering_before_suggestions_at = true,
  position,
  itemRef,
  colorSecondary,
  isGridCard,
}) => {
  const gridWrapperClass = isGridCard ? ` ${position}-item__grid-qts-open` : "";
  const baseClassName = editable
    ? `${position}-item__edit-qts`
    : `${position}-item__cant-edit-qts`;
  if (
    (editable && allow_ordering_before_suggestions_at) ||
    position == "cart"
  ) {
    return (
      <div
        className={classNames(baseClassName, gridWrapperClass)}
        style={{ borderColor: colorSecondary }}
        ref={itemRef}
      >
        {children}
      </div>
    );
  }

  return (
    <div
      className={classNames(baseClassName, gridWrapperClass)}
      style={{ borderColor: colorSecondary }}
      ref={itemRef}
    ></div>
  );
};

function QuantityControl({
  num_portions_in_cart,
  editable,
  allow_ordering_before_suggestions_at,
  position,
  colorSecondary,
  handleDecrementClick,
  handleIncrementClick,
  handleAddClick,
  handleDropdownQuantityChange,
  itemRef,
  isGridCard,
  disableIncrement,
}) {
  const shouldOnClickAllowed = editable && !disableIncrement;
  const shouldDisableDecrement = num_portions_in_cart === 0;
  const onQuantityClickHandler = (withoutDisableFn, shouldDisable) =>
    shouldOnClickAllowed && !shouldDisable ? withoutDisableFn : () => {};
  const valueToShow = num_portions_in_cart;
  const increaseClass = editable
    ? `${position}-item__edit-qts-plus`
    : `${position}-item__cant-edit-qts-plus`;
  const decreaseClass = classNames({
    [`${position}-item__edit-qts-minus`]: editable && !shouldDisableDecrement,
    [`${position}-item__cant-edit-qts-minus`]: !editable,
    [`${position}-item__cant-edit-qts-minus-only`]: shouldDisableDecrement,
  });
  const numInCartClass = editable
    ? `${position}-item__edit-qts-num`
    : `${position}-item__cant-edit-qts-num`;

  function handleQuantityChange(e, selectedNum) {
    const difference = selectedNum - valueToShow;
    handleDropdownQuantityChange(e, difference);
  }

  if (position === "cart") {
    return (
      <QuantityControlWrapper
        editable={editable}
        allow_ordering_before_suggestions_at={false}
        position={position}
        itemRef={itemRef}
        colorSecondary={colorSecondary}
      >
        <p
          className={decreaseClass}
          style={{ color: colorSecondary }}
          onClick={onQuantityClickHandler(
            handleDecrementClick,
            shouldDisableDecrement,
          )}
        >
          -
        </p>
        <QuantityDropdown
          value={valueToShow}
          onNumberSelect={handleQuantityChange}
          numInCartClass={numInCartClass}
          colorSecondary={colorSecondary}
          editable={editable}
          position={position}
          source="cart"
        />
        <p
          className={increaseClass}
          style={{ color: colorSecondary }}
          onClick={onQuantityClickHandler(handleIncrementClick, false)}
        >
          +
        </p>
      </QuantityControlWrapper>
    );
  }
  if (editable && position === "catalog" && num_portions_in_cart === 0) {
    const gridWrapperClass = isGridCard ? ` ${position}-item__grid-qts` : "";
    let containerClass = editable
      ? `${position}-item__edit-qts-add-container`
      : `${position}-item__cant-edit-qts-add-container`;
    const buttonClass = editable
      ? `${position}-item__edit-qts-add`
      : `${position}-item__cant-edit-qts-add`;

    const newClsname = classNames(containerClass, {
      disabled_increment: disableIncrement,
    });

    return (
      <div
        className={classNames(newClsname, gridWrapperClass)}
        onClick={onQuantityClickHandler(handleAddClick, false)}
      >
        <p className={buttonClass}>+</p>
      </div>
    );
  }
  return (
    <QuantityControlWrapper
      editable={editable}
      allow_ordering_before_suggestions_at={
        allow_ordering_before_suggestions_at
      }
      position={position}
      itemRef={itemRef}
      colorSecondary={colorSecondary}
      isGridCard={isGridCard}
    >
      <p
        className={decreaseClass}
        style={{ color: colorSecondary }}
        onClick={onQuantityClickHandler(
          handleDecrementClick,
          shouldDisableDecrement,
        )}
      >
        -
      </p>
      <QuantityDropdown
        value={num_portions_in_cart}
        onNumberSelect={handleQuantityChange}
        numInCartClass={numInCartClass}
        colorSecondary={colorSecondary}
        editable={editable}
        position={position}
      />
      <p
        className={increaseClass}
        style={{ color: colorSecondary }}
        onClick={onQuantityClickHandler(handleIncrementClick, false)}
      >
        +
      </p>
    </QuantityControlWrapper>
  );
}

export default QuantityControl;
